import React from 'react'
import successIcon from "assets/images/images_new/success-icon.png";
import { NavLink } from "react-router-dom";
import { Button } from 'react-bootstrap';

const SuccessCard = () => {
  return (
   <div className="transation-page payment-successful outer-wrapper">
            <div className="successful-content">
              <img src={successIcon} alt="LA" />
              <h2>Subscription created successful</h2>
              <p>Transaction was successful <br /> and your subscription will be activate soon</p>
              <div className="payment-btns d-flex justify-content-center align-items-center">
                {/* <a href="#" className="pay-btn dashboard-btn">Go To Dashboard</a> */}
                <NavLink to={"/admin/dashboard"} className="text-decoration-none">
                <Button size="xs" className="process-payment-btn d-flex align-items-center">
                  Go to Dashboard
                </Button>
              </NavLink>
                 <NavLink to={"/admin/transaction"}>
                <Button size="xs" className="process-payment-btn d-flex align-items-center">
                  Manage Plan
                </Button>
              </NavLink>
                {/* <a href="#" className="pay-btn manage-btn">Manage Plan</a> */}
              </div>
            </div>
          </div>
  )
}

export default SuccessCard
